import Highcharts from 'highcharts';

export const EPD_MATERIAL_CHART_OPTIONS: Highcharts.Options = {
  chart: {
    plotBorderWidth: null,
    plotShadow: false,
    type: 'pie',
    height: 320
  },
  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  colors: [
    '#003c4f',
    '#00747a',
    '#dcf600',
    '#01c9b3',
    '#b0c3c8',
    '#003133',
    '#5c6700',
    '#b0eee7',
    '#001921',
    '#b0d4d6',
    '#f4fcb0',
    '#00544b',
    '#002b38',
    '#54a2a6',
    '#e8f954',
    '#018f7f',
    '#018f7f',
    '#547c89',
    '#005257',
    '#9caf00',
    '#55dbcc'
  ],
  plotOptions: {
    pie: {
      shadow: false,
      innerSize: '80%',
      borderWidth: 4,
      showInLegend: true,
      dataLabels: {
        enabled: true,
        distance: 10,
        format: '{point.name}: {point.y:.1f} %'
      }
    },
    series: {
      point: {
        events: {}
      },
      events: {},
      states: {
        inactive: {
          opacity: 1
        },
        hover: {
          enabled: true
        }
      },
      animation: false
    }
  },
  legend: {
    symbolHeight: 10,
    symbolWidth: 10,
    symbolPadding: 4,
    symbolRadius: 0,
    layout: 'horizontal',
    align: 'right',
    verticalAlign: 'bottom'
  },
  series: [
    {
      type: 'pie',
      name: '',
      data: []
    }
  ]
};

export const EPD_CLIMATE_CHART_OPTIONS: Highcharts.Options = {
  chart: {
    type: 'column',
    height: 300
  },
  title: {
    text: null
  },
  credits: {
    enabled: false
  },
  colors: ['#003C4F', '#547080', '#339095', '#FFA76B'],
  xAxis: {
    categories: []
  },
  yAxis: {
    min: 0,
    title: {
      text: ''
    }
  },
  plotOptions: {
    column: {
      stacking: 'normal',
      dataLabels: {
        enabled: true // Enable data labels
      }
    }
  },
  legend: {
    enabled: false
  },
  series: []
};

export const EPD_CARBON_FOOTPRINT_CHART_OPTIONS = (total: number, chartData: any[]): Highcharts.Options => ({
  credits: {
    enabled: false
  },
  chart: {
    height: '',
    plotBorderWidth: null,
    plotShadow: false
  },
  title: {
    text: null
  },
  colors: ['#003C4F', '#547080', '#339095', '#FFA76B'],
  plotOptions: {
    pie: {
      shadow: false,
      center: [null, 110],
      size: '220px',
      innerSize: '70%',
      dataLabels: {
        enabled: false
      },
      showInLegend: true
    },
    series: {
      point: {
        events: {
          legendItemClick() {
            return false;
          }
        }
      },
      states: {
        inactive: {
          opacity: 1
        },
        hover: {
          enabled: false
        }
      },
      animation: false
    }
  },
  legend: {
    enabled: true,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
    itemMarginTop: 4,
    itemMarginBottom: 4,
    maxHeight: 120,
    margin: 0,
    itemStyle: {
      color: '#42454B',
      fontWeight: '100'
    },
    symbolHeight: 12,
    symbolWidth: 12,
    symbolRadius: 6,
    y: 5
  },
  series: [
    {
      type: 'pie',
      name: '',
      data: chartData
    }
  ]
});
export const EPD_CHG_CHART_OPTIONS = (total: number, chartData: any[]): Highcharts.Options => ({
  credits: {
    enabled: false
  },
  chart: {
    height: '',
    plotBorderWidth: null,
    plotShadow: false
  },
  title: {
    text: null
  },
  colors: ['#003C4F', '#547080', '#339095', '#FFA76B'],
  plotOptions: {
    pie: {
      shadow: false,
      center: [null, 110],
      size: '220px',
      innerSize: '70%',
      dataLabels: {
        enabled: false
      },
      showInLegend: true
    },
    series: {
      point: {
        events: {
          legendItemClick() {
            return false;
          }
        }
      },
      states: {
        inactive: {
          opacity: 1
        },
        hover: {
          enabled: false
        }
      },
      animation: false
    }
  },
  legend: {
    enabled: true,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
    itemMarginTop: 4,
    itemMarginBottom: 4,
    maxHeight: 120,
    margin: 0,
    itemStyle: {
      color: '#42454B',
      fontWeight: '100'
    },
    symbolHeight: 12,
    symbolWidth: 12,
    symbolRadius: 6,
    y: 5
  },
  series: [
    {
      type: 'pie',
      name: '',
      data: chartData
    }
  ]
});
